export type CreateExternalUserRequestBody = {
  email: string;
};
